export default {
  jobs: [],
  jobFilters: [],
  jobFilterJobs: [],
  userJobs: [],
};
